export default __webpack_public_path__ + "static/media/H0000.f0ed295e.png";